export type NumericRange =
    | "positive-integer"
    | "non-negative-integer"
    | "negative-integer"
    | "non-positive-integer"
    | "positive-decimal"
    | "non-negative-decimal"
    | "negative-decimal"
    | "non-positive-decimal"
    | "integer"
    | "decimal"

export type MonetaryRange = "positive" | "non-negative" | "negative" | "non-positive" | "all"

export function isIntegerRange(range: NumericRange): boolean {
    return range.includes("integer")
}

export function rangeAllowsNegative(range: NumericRange): boolean {
    return (
        range === "negative-integer" ||
        range === "non-positive-integer" ||
        range === "negative-decimal" ||
        range === "non-positive-decimal" ||
        range === "integer" ||
        range === "decimal"
    )
}

// Strict upper bound at input time; the "must be < 0" case is enforced by validation, not masking.
export function rangeIsNonPositive(range: NumericRange): boolean {
    return (
        range === "negative-integer" ||
        range === "non-positive-integer" ||
        range === "negative-decimal" ||
        range === "non-positive-decimal"
    )
}

export function monetaryRangeAllowsNegative(range: MonetaryRange): boolean {
    return range === "negative" || range === "non-positive" || range === "all"
}

export function monetaryRangeIsNonPositive(range: MonetaryRange): boolean {
    return range === "negative" || range === "non-positive"
}
